export function followHost() {
  const { followingUser, clients } = this.getRootState()
  const data = this.getCanvasScope()
  const clientCanvas = clients?.[followingUser]
  const Collection = this.getCanvasCollection()

  if (!clientCanvas || !Collection) {
    return
  }

  const {
    selected: clientSelected,
    chosen: clientChosen,
    openUrl
  } = clientCanvas

  if (data.openUrl !== openUrl) {
    data.openUrl = openUrl
    if (openUrl) {
      if (data.openedWindow) data.openedWindow.close()
      data.openedWindow = window.open(openUrl)
    } else {
      ;(data.openedWindow || window)?.close()
      data.openedWindow = null
    }
  }

  const { followingUser: skip, ...cleanData } = clientCanvas
  this.call('overwrite', data, cleanData)

  if (this.getSelectedKey() !== clientSelected) {
    this.activateSelected(clientSelected)
  }

  if (this.getChosenKey() !== clientChosen) {
    this.activateChosen(clientChosen)
  }

  this.variables({ previewSize: data.previewSize }).changed((_) => {
    this.getChosenSceneNavbar().update()
  })

  this.variables({ componentEditor: data.componentEditor }).changed((_) => {
    this.setWindow('componentEditor', data.componentEditor)
  })

  this.variables({ explorer: data.explorer }).changed((_) => {
    this.setWindow('explorer', data.explorer)
  })

  this.variables({
    hoverLayer: data.hoverLayer,
    activeLayer: data.activeLayer
  }).changed((_) => {
    this.getDynamicIsland().update({})
    this.getEditorPanels().parent.update({})
  })
}

export async function setFollowingUser(userId) {
  let { clients } = this.getRootState()

  const client = clients?.[userId]
  if (!client || userId === this.getRootState('userId')) return

  const followingUser =
    this.getRootState().followingUser === userId ? null : userId

  this.syncCanvas({ followingUser }, { forceSendSocket: true })
}

export function askToFollow(targetUserId) {
  const { clients, userId } = this.getRootState()
  if (userId === targetUserId) return
  const client = clients?.[userId]
  if (!client) {
    return
  }
}

export function clearFollowing() {
  const rootState = this.getRootState()
  if (!rootState.followingUser) {
    return
  }
  rootState.followingUser = null
}
